/**
 * Colossus - PrebidJS Adapter
 * Handles header bidding with Colossus
 * version 1.0.0
 * 
 * Using Semantic Versioning, please update accordingly to keep files in sync across code bases
 * 
 * Given a version number MAJOR.MINOR.PATCH, increment the:
 *  1. MAJOR version when you implement a full re-build of the architecture,
 *  2. MINOR version when you add functionality, and
 *  3. PATCH version when you implement bug fixes or make small  tweaks to current functionality.
 */
define('AdBidders/adapters/colossus',[
    "jquery",
    "logging",
    "utilities"
], function ($, logging, utilities) {
    "use strict";
    var _ModuleName = "Colossus";

    var _config = {}

    var _initialized = false;
    var init = function (config) {
        if (!_initialized) {
            $.extend(_config, config);
            _initialized = true;
        }
    }

    var getBidDefinition = function (slot) {
        // make sure we're initialized
        if (!_initialized) { return; }

        ;

        var bids = [];
        if (_config.placements) {
            for (var i = 0; i < _config.placements.length; i++) {
                var placement = _config.placements[i];

                if (((slot.mobile && placement.mobile) || (!slot.mobile && placement.desktop))  // slot and zone mobile setting must match
                    && utilities.isArrayInArray(slot.sizes, placement.size)                          // slot must contain eligible size for zone
                    ) {

                    bids.push(
                        $.extend({}, {
                            bidder: _config.name,
                            params: {
                                placement_id: placement.placementId
                            }
                        })
                    );
                }
            }
        }

        return bids;
    }

    var getBidderSettings = function () {
        return {}
    }

    return {
        name: _ModuleName,
        init: init,
        getBidDefinition: getBidDefinition,
        getBidderSettings: getBidderSettings
    }
});
